import { Navigate, Outlet } from "react-router-dom";

import { needsWelcome, WELCOME_PATH } from "~/lib/onboarding";
import { useAuthStore } from "~/store/auth-store";

/**
 * Layout route sending a member who has never been through the welcome screen there
 * first, instead of to the dashboard.
 *
 * It wraps the app's content routes and not `/welcome` itself, which is what stops the
 * redirect from chasing its own tail. Sitting inside `MemberGate` also keeps the order
 * of the two questions right: a non-member belongs on the paywall, not on an
 * orientation page for content they cannot open yet.
 *
 * Nothing here is a security boundary — the welcome screen guards nothing. It is a
 * first-run experience, so a member who presses through it is let in immediately even
 * if the acknowledgement never reached the API (see `lib/onboarding.ts`).
 */
export function OnboardingGate() {
  const user = useAuthStore((state) => state.user);
  return needsWelcome(user) ? (
    <Navigate to={WELCOME_PATH} replace />
  ) : (
    <Outlet />
  );
}
